module.exports = __webpack_public_path__ + "static/media/drizzle.5eccaf9c.jpeg";